import moment from "moment";
import config from "../config";

let timeoutId = null;

export function inputOnlyNumbers(input){
    const regex = /^[0-9]*$/;
    
    return regex.test(input);
}

export function inputOnlyNumbersWithComma(input){
    const regex = /^[[0-9]*[,]?[0-9]*]*$/

    return regex.test(input);
}

export function inputOnlyNumbersWithDot(input){
    const regex = /^[[0-9]*[.]?[0-9]*]*$/

    return regex.test(input);
}

export function preventCoordsErrInput(input){
    if(input[0] === '.'){
        input = '0'+input;
    }
    let last = input.slice(-1);
    if(last === '.'){
        input = input+'0';
    }
    if(input === ''){
        input = '0.0'
    }
    return input;
}

export function testNumberInputPercentages(input){
    const regex = /^[1-9][0-9]?$|^100$/;

    return regex.test(input);
}

export function testPasswordValidator(input){
    const regexPassword = /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&\/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&\/\\,><':;|_~`=+\- ]{14,256}$/
    
    return regexPassword.test( input );
}

export function testNumberInputPercentagesTwoDecimals(input){
    const regexPercentagesTwoDecimals = /(^100([.]0{1,2})?)$|(^\d{1,2}([,]\d{1,2})?)$/;
    
    return regexPercentagesTwoDecimals.test( input );
}

export function testEmail(input){
    const regexEmailValidator = /^[a-z0-9]+([.\-_]?[a-z0-9]+)+@[a-z0-9]+([.\-_]?[a-z0-9]+)+\.[a-z]{2,}$/;

    return regexEmailValidator.test(input);
}

export function formatNumbersIt(inputValue){
    if(inputValue===undefined)return '';
    return new Intl.NumberFormat('it-IT').format(inputValue);
}

export function formatNumbersItNoSeparator(inputValue){
    if(inputValue===undefined)return '';
    return new Intl.NumberFormat('it-IT',{useGrouping: false}).format(inputValue);
}

export function formatNum( value, decimals = 2 ) {
    return value.toFixed( decimals )
}

export function getFormatDateFromDate(inputDate, separatorChar = '/'){
    //torna una stringa in formato dd/mm/yyyy a partire da un Date
    //separatore di default è / però indicarne uno diverso per i file generati siccome / è riservato
    let month = '' + (inputDate.getMonth() + 1);
    let day = '' + inputDate.getDate();
    let year = inputDate.getFullYear();

    if (month.length < 2)month = '0' + month;
    if (day.length < 2)day = '0' + day;

    return [day, month, year].join(separatorChar);
}

export function getFormatDate(inputDate) {
    //torna una stringa in formato dd/mm/yyyy a partire da una stringa formato 'YYYYMMDD...'

    let retVal = '';

    try {
        const yyyy = inputDate.substring(0, 4);
        const mm = inputDate.substring(4, 6);
        const dd = inputDate.substring(6, 8);

        retVal = `${dd}/${mm}/${yyyy}`;
        
    }catch (err) {
        //config.ENV === 'dev' && console.log('CommonUtilities - getFormatDate' + err.message);
    }

    return retVal;
}

export function getFormatDateTime(inputDate) {
    //torna una stringa in formato dd/mm/yyyy hh24:mi:ss a partire da una stringa formato 'YYYYMMDDHH24MISS'

    let retVal = '';

    try {
        const yyyy = inputDate.substring(0, 4);
        const mm = inputDate.substring(4, 6);
        const dd = inputDate.substring(6, 8);

        let hh= '';
        let mi= '';
        let ss= '';
        hh = inputDate.substring(8, 10);
        mi = inputDate.substring(10, 12);
        ss = inputDate.substring(12, 14);

        retVal = `${dd}/${mm}/${yyyy} ${hh}:${mi}:${ss}`;
        
    }catch (err) {
        config.ENV === 'dev' && console.log('CommonUtilities - getFormatDateTime' + err.message);
    }

    return retVal;
}

export function getFormatDateTimeMilliseconds(inputDate) {
    //torna una stringa in formato dd/mm/yyyy hh24:mi:ss a partire da una stringa formato 'YYYYMMDDHH24MISS'

    let retVal = '';

    try {
        const yyyy = inputDate.substring(0, 4);
        const mm = inputDate.substring(4, 6);
        const dd = inputDate.substring(6, 8);

        let hh= '';
        let mi= '';
        let ss= '';
        let sss = '';
        hh = inputDate.substring(8, 10);
        mi = inputDate.substring(10, 12);
        ss = inputDate.substring(12, 14);
        sss = inputDate.substring(14, 17);

        retVal = `${dd}/${mm}/${yyyy} ${hh}:${mi}:${ss}.${sss}`;
        
    }catch (err) {
        config.ENV === 'dev' && console.log('CommonUtilities - getFormatDateTime' + err.message);
    }

    return retVal;
}

export function getFormatDateTimeMillisecondsItFormat(inputDate) {
    //torna una stringa in formato dd/mm/yyyy hh24:mi:ss a partire da una stringa formato 'YYYYMMDDHH24MISS'

    let retVal = '';

    try {
        const yyyy = inputDate.substring(0, 4);
        const mm = inputDate.substring(4, 6);
        const dd = inputDate.substring(6, 8);

        let hh= '';
        let mi= '';
        let ss= '';
        let sss = '';
        hh = inputDate.substring(8, 10);
        mi = inputDate.substring(10, 12);
        ss = inputDate.substring(12, 14);
        sss = inputDate.substring(14, 17);

        //retVal = `${dd}/${mm}/${yyyy} ${hh}:${mi}:${ss}.${sss}`;
        let dateToRender = new Date(`${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}.${sss}Z`);
        return dateToRender.toLocaleString("it-IT")
    }catch (err) {
        config.ENV === 'dev' && console.log('CommonUtilities - getFormatDateTime' + err.message);
    }

    return retVal;
}

export function getHoursUtc(){
    //torna una stringa formato 'hhmmss'  a partire da un Date UTC
    let data = new Date();

    let h = data.getHours()+'';
    h = h.length === 1 ? '0'+h : h;
    let m = data.getMinutes()+'';
    m = m.length === 1 ? '0'+m : m;
    let s = data.getSeconds()+'';
    s = s.length === 1 ? '0'+s : s;
    
    return `${h}${m}${s}`;
}

export function getStringFromDate(inputDate) {
    //torna una stringa formato 'YYYYMMDD'  a partire da un Date

    let retVal = '';

    try {
        if ( moment( inputDate ).isValid() ) {
            const d = inputDate.getDate().toString().padStart(2, '0');
            const m = (inputDate.getMonth() + 1).toString().padStart(2, '0');
            const y = inputDate.getFullYear().toString().padStart(4, '0');
            retVal = `${y}${m}${d}`;
        }
    }catch (err) {
        config.ENV === 'dev' && console.log('CommonUtilities - getStringFromDate ' + err.message);
    }

    return retVal;
}

export function getStringMonthYearFromDate(inputDate, fullText = false) {
    //torna una stringa formato 'YYYYMMDD'  a partire da un Date

    let retVal = '';

    try {
        if ( moment( inputDate ).isValid() ) {
            const m = (inputDate.getMonth() + 1).toString().padStart(2, '0');
            const y = inputDate.getFullYear().toString().padStart(4, '0');
            if(fullText){
                let arrMonths = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre']

                retVal = `${arrMonths[(parseInt(m)-1)]} ${y}`
            }else{
                retVal = `${y}${m}`;
            }
        }
    }catch (err) {
        config.ENV === 'dev' && console.log('CommonUtilities - getStringFromDate ' + err.message);
    }

    return retVal;
}

export function getDateFromString(inputDate) {
    //torna un Date a partire da una stringa formato 'YYYYMMDD'

    let retVal = null;

    try {
        retVal = new Date(parseInt(inputDate.substring(0, 4)), parseInt(inputDate.substring(4, 6)) - 1, parseInt(inputDate.substring(6, 8)));
    }catch (err) {
        config.ENV === 'dev' && console.log('CommonUtilities - getDateFromString' + err.message);
    }

    return retVal;
}

export function getDateFromBucketStringDate(inputDate){
    //torna una stringa in formato DD/MM/YYYY a partire da una stringa di un bucket in formato yyyy-mm-dd hh24:mi:ss

    let retVal = '';

    try {
        const yyyy = inputDate.substring(0, 4);
        const mm = inputDate.substring(5, 7);
        const dd = inputDate.substring(8, 10);

        retVal = `${dd}/${mm}/${yyyy}`;
        
    }catch (err) {
        config.ENV === 'dev' && console.log('CommonUtilities - getDateFromBucketStringDate' + err.message);
    }

    return retVal;
}
    
export function debounce(fn, time) {

    function wrapper(...args) {

        if ( timeoutId ) {
            clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(
            () => {
                timeoutId = null;
                fn(...args);
            }, time
        );

    }

    return wrapper;
}

export function inputOnlyNumbersWithDecimals(input) {
    const regex = /^[[0-9]*[.]?[0-9]*]*$/;

    return regex.test(input);
}